<template>
    <div>
        <!--自动充值暂未上线，请联系刘老师：13357720793-->
        <div>请输入充值金额：￥ <input type="text" placeholder="请输入充值金额" class="recharge_amount_input" v-model="recharge_amount">
        </div>

        <div style="font-size: 20px;margin-top: 10px;margin-bottom: 10px;color: #565656;font-weight:700">支付方式</div>
        <div>
            <img v-for="mode in available_pay_modes" :key="mode.id" @click="change_select_pay_mode(mode)"
                 style="padding: 10px 20px;width: 120px;margin-left: 20px"
                 :class="select_pay_mode.id == mode.id ? 'select_active':'select_inactive' "
                 :src="'/static/img/'+mode.type+'_logo.png'">
        </div>
        <div style="margin-top: 20px" v-if="select_pay_mode.type=='wxpay' && wxpay_code_url">
            <div>
                请使用微信扫一扫付款
            </div>

            <vue-qr :text="wxpay_code_url" :size="180"></vue-qr>

            <button class="btn pay_confirm_button" @click="pay_success_confirm">
                支付确认
            </button>
            <div>
                提醒：若您已支付成功，但页面长时间没有响应，请点<span style="color: red">支付确认</span>按钮
            </div>

        </div>
        <div class="footer" style="margin-top: 50px;height: 30px">
            <span style="font-size: 27px;float: left">付款：<span style="color: red">￥{{recharge_amount}}</span></span>
            <el-button v-if="select_pay_mode.type=='alipay'" style="float: right" type="primary" @click="confirm_pay"
                       :disabled="recharge_amount<=0">确 定
            </el-button>
        </div>

    </div>
</template>
<script type="text/javascript">
    import accountApi from '@/api/account/account.js'
    import {mapState, mapActions} from 'vuex'
    import VueQr from 'vue-qr'

    export default {
        props: {
            recharge_amount: {
                type: String,
                require: true,
                default: '1'
            },
            no_reload: {},
        },
        data: function () {
            return {
                // 'recharge_amount': 1,
                'available_pay_modes': [],
                'select_pay_mode': {},
                'form_html': '',
                'wxpay_code_url': '',
                'pay_record_name': '',
            }
        },
        components: {VueQr},
        computed: {
            ...mapState({
                // user_info: state => state.loginState.user_info
            }),
        },
        watch: {
            recharge_amount: function () {
                if (this.select_pay_mode.type == 'wxpay') {
                    let args = {
                        'mode_id': this.select_pay_mode.id,
                        'amount': this.recharge_amount,
                    }
                    accountApi.generate_wxpay_code_url(args).then(res => {
                        console.log(res)
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            if (data.wx_return.return_code == 'SUCCESS' && data.wx_return.result_code == 'SUCCESS') {
                                this.wxpay_code_url = data.wx_return.code_url
                                this.pay_record_name = data.pay_record_name
                            }
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'warning'
                            });
                        }
                    })
                }
            }
        },
        methods: {
            change_select_pay_mode(mode) {
                this.select_pay_mode = mode
                if (mode.type == 'wxpay') {
                    let args = {
                        'mode_id': this.select_pay_mode.id,
                        'amount': this.recharge_amount,
                    }
                    accountApi.generate_wxpay_code_url(args).then(res => {
                        console.log(res)
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            if (data.wx_return.return_code == 'SUCCESS' && data.wx_return.result_code == 'SUCCESS') {
                                this.wxpay_code_url = data.wx_return.code_url
                                this.pay_record_name = data.pay_record_name
                            }
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'warning'
                            });
                        }
                    })
                }
            },
            confirm_pay() {
                if (this.select_pay_mode.type == 'alipay') {
                    let args = {
                        'mode_id': this.select_pay_mode.id,
                        'amount': this.recharge_amount,
                        'state': 'process',
                    }
                    accountApi.create_pay_record(args).then((res) => {
                        console.log(res)
                        let data = JSON.parse(res.data.result);
                        if (data.code == 'success') {
                            accountApi.alipay_form_generate_values({
                                'mode_id': this.select_pay_mode.id,
                                'reference': data.pay_record.name,
                                'amount': data.pay_record.amount,
                            }).then((res) => {
                                this.form_html = res.data.result
                                const div = document.createElement('div')
                                /* 下面的data.content就是后台返回接收到的数据 */
                                div.innerHTML = this.form_html

                                document.body.appendChild(div)

                                document.forms[0].submit()

                            })
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'warning'
                            });
                        }
                    })


                }
                if (this.select_pay_mode.type == 'wxpay') {
                    alert('微信支付暂不可用，请使用支付宝')
                }

            },
            pay_success_confirm() {
                let args = {
                    'pay_record_name': this.pay_record_name,
                }
                accountApi.pay_success_confirm(args).then(res => {
                    console.log(res)
                    if (res.data.code == 'success') {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        if (!this.no_reload){
                            setTimeout(function () {
                                location.reload();
                            }, 2000);
                        }else{
                            console.log('pay message_back')
                            this.$emit('message_back')
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            }
        },
        mounted() {
            let args = {}
            accountApi.get_pay_mode(args).then((res) => {
                if (res.data.code == 'success') {
                    this.available_pay_modes = res.data.modes
                    this.select_pay_mode = res.data.modes[0]
                    if (this.select_pay_mode.type == 'wxpay') {
                        let args = {
                            'mode_id': this.select_pay_mode.id,
                            'amount': this.recharge_amount,
                        }
                        accountApi.generate_wxpay_code_url(args).then(res => {
                            console.log(res)
                            let data = JSON.parse(res.data.result)
                            if (data.code == 'success') {
                                if (data.wx_return.return_code == 'SUCCESS' && data.wx_return.result_code == 'SUCCESS') {
                                    this.wxpay_code_url = data.wx_return.code_url
                                    this.pay_record_name = data.pay_record_name
                                }
                            } else {
                                this.$message({
                                    message: data.message,
                                    type: 'warning'
                                });
                            }
                        })
                    }
                }
            })
            let that = this
            setInterval(function () {
                if (that.select_pay_mode.type == 'wxpay') {
                    let args = {
                        'pay_record_name': that.pay_record_name,
                    }
                    accountApi.pay_success_confirm(args).then(res => {
                        if (res.data.code == 'success') {
                            that.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            setTimeout(function () {
                                location.reload();
                            }, 2000);
                        }
                    })
                }

            }, 4000)

        }
    }
</script>
<style type="text/css" scoped>
    .select_active {
        border: 2px solid #f55f60;
    }

    .select_inactive {
        border: 1px dashed #d2d2d2;
    }

    .recharge_amount_input {
        /*font-size: 20px;*/
        /*padding: .375rem .75rem;*/
        /*width: 100%;*/
        /*line-height: 1.5;*/
        border: 0;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #333;
        background: #f9f9f9;
    }


    .pay_confirm_button {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }

    .pay_confirm_button:hover {
        color: #fff;
        background-color: #66CCDA;
        border-color: #66CCDA;
    }
</style>

